import React from 'react';
import { useTranslation } from 'next-i18next';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';
import styles from './style.module.scss';
import { useIsMobile } from 'hooks/use-size-class';
import { buildClassName } from 'utils/build-class-name';
import Button from 'components/control/button';
import ExpandIcon3 from 'components/icon/expand-icon-3';

interface MapCardProps {
  trackMapCardClick?: () => void;
}

export default function MapButtonCard({ trackMapCardClick }: MapCardProps) {
  const isMobile = useIsMobile();
  const { t } = useTranslation(Namespaces.COMMON);

  return (
    <div className={buildClassName(styles['card-wrapper'], isMobile && styles['mobile-card-wrapper'])} onClick={trackMapCardClick}>
      <Button
        theme={'secondary'}
        Icon={ExpandIcon3}
        label={t(LOCALE_COMMON_PATHS.LISTING_CARD_VIEW_MAP_BUTTON_LABEL, {
          defaultValue: 'View Map',
        })}
        className={styles.button}
      />
    </div>
  );
}
